import { useEffect, useState } from "react";
import api from "@/lib/api";
import { GraduationCap, KeyRound, Shield } from "lucide-react";
import BackButton from "@/components/BackButton";

const ROLE_BADGE = {
  student: { Icon: GraduationCap, color: "bg-primary text-primary-foreground" },
  teacher: { Icon: KeyRound, color: "bg-accent text-accent-foreground" },
  admin: { Icon: Shield, color: "bg-foreground text-background" },
};

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/admin/users");
      setUsers(data);
    })();
  }, []);

  return (
    <div className="p-6 md:p-10">
      <BackButton />
      <div className="mt-5 mb-8">
        <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
          /users
        </div>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter">
          User Management
        </h1>
      </div>

      <div className="border-2 border-foreground bg-background">
        <div className="mono grid grid-cols-12 gap-2 border-b border-border bg-muted px-4 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">
          <div className="col-span-1">Role</div>
          <div className="col-span-3">Name</div>
          <div className="col-span-4">Email</div>
          <div className="col-span-2 text-right">Wallet</div>
          <div className="col-span-2 text-right">Joined</div>
        </div>
        {users.map((u) => {
          const r = ROLE_BADGE[u.role] || ROLE_BADGE.student;
          return (
            <div
              key={u.id}
              className="grid grid-cols-12 items-center gap-2 border-b border-border px-4 py-3 text-sm last:border-b-0"
            >
              <div className="col-span-1">
                <div className={`flex h-8 w-8 items-center justify-center ${r.color}`}>
                  <r.Icon className="h-4 w-4" />
                </div>
              </div>
              <div className="col-span-3 font-semibold">{u.name}</div>
              <div className="col-span-4 mono text-xs text-muted-foreground">
                {u.email}
              </div>
              <div className="col-span-2 text-right font-mono">
                ${(u.wallet_balance || 0).toFixed(2)}
              </div>
              <div className="col-span-2 text-right mono text-[10px] text-muted-foreground">
                {new Date(u.created_at).toLocaleDateString()}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
